import { formatMoney } from 'accounting'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faPencilAlt, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Checkbox, IconWithMenu, Link, Text,
} from '@domain-group/suit-theme'

import useArtwork from '@hooks/useArtwork'
import useRedirectUrlWithCacheKey from '@hooks/useRedirectUrlWithCacheKey'

import useCampaignItem from '@hooks/useCampaignItem'

import type { CampaignItemModel } from '@models/types'

import OrderContainer from '../../../../components/OrderContainer'

interface CampaignItemProps {
  callbacks: {
    selectCampaignItemId: VoidFunction,
  },
  campaignItem: CampaignItemModel,
  isSelected?: boolean,
}

const CampaignItem = (props: CampaignItemProps) => {
  const {
    callbacks: { selectCampaignItemId },
    campaignItem,
    isSelected,
  } = props

  const campaignItemPayload = useCampaignItem(campaignItem)
  const {
    callbacks: { deleteCampaignItem: deleteFn, createCreditNoteAndDeleteOrder },
    campaignItem: { id, price_override },
  } = campaignItemPayload

  const artworkId = campaignItem?.data?.artwork_id

  const { redirectUrl } = useRedirectUrlWithCacheKey([campaignItem.id])

  const artworkPayload = useArtwork(
    { id: artworkId },
    {
      generateUrlsOptions: {
        includeRedirect: true,
        redirectUrl,
      },
    },
  )

  const {
    urls: { editArtworkUrl },
  } = artworkPayload

  return (
    <OrderContainer>
      <OrderContainer.Items>
        <Box borderColor="lineColor" flexDirection="column" padding="large">
          <Text fontSize="small">{campaignItem?.title}</Text>
        </Box>
      </OrderContainer.Items>

      <OrderContainer.Footer>
        <Checkbox checked={isSelected} onClick={selectCampaignItemId} />

        <Box alignItems="center" width={['100%', 'auto']}>
          <Box flexDirection="column" fontSize="xsmall">
            <Text color="lightGrey">Item #{id}</Text>

            <Text color="bodyFontLightColor" marginTop="small">
              Custom Item
            </Text>
          </Box>
        </Box>

        <Box
          alignItems="center"
          justifyContent="flex-end"
          marginLeft={[0, 'auto']}
          marginTop={['large', 0]}
          width={['100%', 'auto']}
        >
          <Box
            alignItems={['flex-start', 'flex-end']}
            flexDirection="column"
            flexShrink={0}
            justifyContent="center"
            marginRight={['auto', 0]}
            width="auto"
          >
            <Box alignItems="center" width="auto">
              {/*
               // @ts-expect-error TS2769 */}
              <Text fontSize="medium">{formatMoney(price_override)}</Text>
            </Box>
          </Box>

          <Box alignItems="center" marginLeft="large" width="auto">
            <IconWithMenu
              boxProps={{ position: 'relative' }}
              icon={(
                <Button
                  buttonStyle="secondaryUtility"
                  icon={<FontAwesomeIcon icon={faCog} />}
                  size="medium"
                  style={{ height: 38 }}
                />
              )}
            >
              {/*
               // @ts-expect-error TS2741 */}
              <IconWithMenu.Menu closeOnClick>
                {artworkId && editArtworkUrl && (
                  <Link key="editArtwork" href={editArtworkUrl}>
                    <FontAwesomeIcon icon={faPencilAlt} /> Edit Artwork
                  </Link>
                )}

                <Link key="delete" onClick={() => createCreditNoteAndDeleteOrder({ deleteFn })}>
                  <FontAwesomeIcon icon={faTrashAlt} /> Delete Item
                </Link>
              </IconWithMenu.Menu>
            </IconWithMenu>
          </Box>
        </Box>
      </OrderContainer.Footer>
    </OrderContainer>
  )
}

export default CampaignItem
